<template>
  <div
    class="voice-container"
    v-if="
      qrCodeInfo &&
      (QRCodeType.isEmployee(qrCodeInfo.qrCodeType) ||
        qrCodeInfo.options?.showGuestMic)
    "
  >
    <!--마이크 인식 실패시-->
    <div class="voice-wrap" v-if="deviceRecognitionError">
      <div class="device-wrap">
        <p class="smaller-semibold">{{ $t('no_mic_or_error') }}</p>
      </div>
    </div>

    <!--등록된 마이크가 아무것도 없을 때-->
    <div class="voice-wrap" v-else-if="!anyRegistered">
      <div class="device-wrap">
        <p class="smaller-semibold light">{{ $t('connected_mic') }}</p>
        <p v-if="currentDeviceLabel" class="small-semibold">
          {{ currentDeviceLabel }}
        </p>
      </div>
      <template v-if="isVisibleTss">
        <div class="voice-text-wrap">
          <p class="small">
            {{ $t('tooltip_voice_register') }}
          </p>
        </div>
        <a class="link-small" @click="showRegisterVoiceModal">
          {{ $t('register_voice') }}
        </a>
      </template>
    </div>

    <!--현재 장치가 등록되어 있을 때-->
    <div class="voice-wrap" v-else-if="registeredDeviceId">
      <div class="device-wrap">
        <p class="smaller-semibold light">{{ $t('connected_mic') }}</p>
        <p v-if="currentDeviceLabel" class="small-semibold">
          {{ currentDeviceLabel }}
        </p>
      </div>

      <template v-if="isVisibleTss">
        <div v-if="currentDeviceLabel" class="voice-text-wrap">
          <p class="small">
            {{ $t('registered_voice_comment') }}
          </p>
        </div>

        <div v-else class="voice-text-wrap">
          <p class="small">
            {{ $t('registered_voice_comment') }}
          </p>
        </div>

        <div class="link-wrapper">
          <!--<p class="link-small" @click="emit('open')">CER</p>-->
          <a class="link-small" @click="showRegisterVoiceModal">
            {{ $t('reregister_voice') }}
          </a>
          <a class="link-small link-dim" @click="deleteVoice">
            {{ $t('delete_voice') }}
          </a>
        </div>
      </template>
    </div>

    <!--다른 장치만 등록되어 있을 때-->
    <div class="voice-wrap" v-else>
      <div class="device-wrap">
        <p class="smallest accent dim">{{ $t('connected_mic') }}</p>
        <p v-if="currentDeviceLabel" class="small accent">
          {{ currentDeviceLabel }}
        </p>
      </div>

      <template v-if="isVisibleTss">
        <div class="voice-text-wrap">
          <p class="small">
            {{ $t('tooltip_another_device_register') }}
          </p>
        </div>
        <a class="link-small" @click="showRegisterVoiceModal">
          {{ $t('register_voice') }}
        </a>
        <!--
        <a class="link-small" @click="emit('open')">CER</a>
        -->
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { QRCodeType } from '@/stores/chat';

const props = withDefaults(
  defineProps<{
    showConnectedDevice: boolean;
    deviceRecognitionError: boolean;
    anyRegistered: boolean;
    currentDeviceLabel: string;
    registeredDeviceId: number | null;
    qrCodeInfo: any;
    deleteVoice: () => void;
    showRegisterVoiceModal: () => void;
  }>(),
  {
    showConnectedDevice: false,
    deviceRecognitionError: false,
    anyRegistered: false,
    currentDeviceLabel: '',
    registeredDeviceId: 0,
    qrCodeInfo: () => ({}),
    deleteVoice: () => {},
    showRegisterVoiceModal: () => {},
  }
);

const emit = defineEmits<{ open: [] }>();

const isVisibleTss = computed<boolean>(() => {
  return !props.qrCodeInfo.qrCodeType.includes('MEETING');
});
</script>

<style scoped lang="scss">
.voice-container {
  display: flex;
  width: 100%;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem;
  border-radius: 8px;
  background-color: var(--surface-primary-dimmer);
  outline: 1px solid var(--border-primary-dim);
}

.voice-wrap {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
}

.device-wrap {
  display: flex;
  flex-direction: column;
  width: fit-content;
  min-width: 7rem;
  align-items: center;
  gap: 0.125rem;
  padding: 0.325rem 1rem;
  background-color: var(--surface-primary-dimmest);
  border-radius: 8px;
}

.voice-text-wrap {
  position: relative;
  display: flex;
  gap: 0.25rem;
  text-align: center;
}

.icon-smaller {
  margin-top: 0.125rem;
}

.entrance-container .link-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.625rem;
  position: relative;
  flex: 1;
  flex-grow: 1;
}
</style>
